import {CardBox, RouterViewTemplate, useLoadingState} from "../RouterView";
import {getContainer} from "../../ioc/IOCSetup";
import * as React from "react";
import {ListRequest, Site} from "../../http/protocol";
import {Link} from "react-router-dom";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {ActionType} from "../list/list/DataTable";
import {ColumnType} from "../list/list/ColumnType";
import {PagerModel} from "../list/list/PagerModel";
import {useState} from "react";


export const ListSettingsView = () => {

    const service = getContainer().getSettingsService();

    const status = useLoadingState(()=>{
        return Promise.resolve();
    },[]);

    const [listRequest, setListRequest]  = useState<ListRequest>({
        limit: 20,
        offset : 0,
        orderBy : "id",
        ascending : false
    });
    const pagerChanged = (pager : PagerModel) => {
        setListRequest({
            offset : pager.offset,
            limit : pager.limit,
            orderBy : pager.orderBy,
            ascending : pager.ascending
        })
    }
    const onAction = (item : any, actionId : string) => {
        return Promise.resolve();
    }


    return (
        <RouterViewTemplate status={status} title={"List Sites"}>
            <CardBox>
                <Link className={"btn btn-primary"} to={"/admin/site/new"}>Create Site</Link>
            </CardBox>
            <EntityDataTable
                service={service}
                listRequest={listRequest}
                columns={[
                    { property : "id", name : "ID" },
                    { property : "title", name : "Title" }
                ]}
                actions={[
                    { type : ActionType.LINK, className : "btn btn-primary", id : "view", name : "Edit", iconClassName : "fa fa-edit", getLink : (item) => `/admin/settings/general/${item.id}`},
                    { type : ActionType.LINK, className : "btn btn-secondary", id : "copy", name : "Copy", iconClassName : "fa fa-copy", getLink : (item) => `/admin/settings/general/new/${item.id}`}
                ]}
                onPagerChange={pagerChanged}
                onAction={onAction}
            />
        </RouterViewTemplate>
    )
}
